<template>
  <div class="row">
    <div class="col-xl-12 col-lg-12">
      <card
        :headerTitle="title"
        hideFooter
        @reload="$emit('reload')"
        :busy="busy"
      >
        <template slot="body">
          <slot name="top">
            <div class="card-block">
              <div class="row">
                <!--div class="col-md-2">
                  <div class="form-group">
                    <input type="text" class="form-control" placeholder="Начальная дата" />
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <input type="text" class="form-control" placeholder="Конечная дата" />
                  </div>
                </div-->
                <div class="col-md-2">
                  <div class="form-group">
                    <div class="position-relative has-icon-left">
                      <input
                        type="text"
                        class="form-control bg-grey bg-lighten-4"
                        :placeholder="searchPlaceholder || 'Поиск'"
                        v-model="private_filter"
                      />
                      <div class="form-control-position">
                        <i class="icon-search4"></i>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-10">
                  <div class="form-group text-xs-right">
                    <!--button href="#" class="btn btn-info btn-min-width" style="margin-right: 10px;">
                      <i class="icon-android-done"></i> Применить
                    </button-->

                    <!--button href="#" class="btn btn-secondary btn-min-width" @click="$emit('download')">
                      <i class="icon-download4"></i> Скачать в формате .xlsх
                    </button-->
                    <DownloadTableXLSXButton
                      v-if="downloadFilename"
                      :filename="downloadFilename"
                      :fields="fields"
                      :items="items"
                    />
                  </div>
                </div>
              </div>
            </div>
          </slot>
          <div class="card-block">
            <p v-if="topCaption">{{ topCaption }}</p>

            <div class="table-responsive">
              <b-table
                show-empty
                hover
                bordered
                responsive
                thead-class="bg-grey bg-lighten-2"
                :emptyText="
                  failed
                    ? 'Ошибка подключения. Попробуйте позже'
                    : 'Записи отсутствуют'
                "
                emptyFilteredText="Записи не найдены"
                :tbody-tr-class="boldRow"
                :items="items"
                :fields="fields"
                :current-page="currentPage"
                :per-page="perPage"
                :filter="filter || private_filter"
                :filterIncludedFields="filterIncludedFields"
                :filter-function="filterFunction"
                @filtered="onFiltered"
              >
                <template v-slot:table-busy>
                  <div class="text-center my-2">
                    <strong>Загружаем...</strong>
                  </div>
                </template>
                <template
                  v-for="slotName in Object.keys($scopedSlots)"
                  v-slot:[slotName]="slotScope"
                >
                  <slot :name="slotName" v-bind="slotScope"></slot>
                </template>
              </b-table>
            </div>
            <div style="margin: 20px 0px">
              <div>Всего записей: {{ totalRows }}</div>
              <div>
                <div class="float-xl-left float-sm-none mt10">
                  <select
                    v-model="perPage"
                    id="issueinput5"
                    name="priority"
                    class="form-control"
                    data-toggle="tooltip"
                    data-trigger="hover"
                    data-placement="top"
                    data-title="На страницу"
                    data-original-title
                    title
                  >
                    <option value="5">5</option>
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                  </select>
                </div>

                <div class="float-xl-right">
                  <nav aria-label="Page navigation">
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="totalRows"
                      :per-page="perPage"
                      size="sm"
                      prev-text="« Пред."
                      next-text="След. »"
                      first-number
                      last-number
                    ></b-pagination>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </template>
      </card>
    </div>
  </div>
</template>

<script>
import DownloadTableXLSXButton from "@/components/DownloadTableXLSXButton.vue";
import card from "@/components/card.vue";

export default {
  name: "BillTable",
  components: {
    DownloadTableXLSXButton,
    card,
  },
  props: {
    title: String,
    topCaption: String,
    busy: Boolean,
    failed: Boolean,
    fields: Array,
    items: Array,
    itemsPerPage: Number,
    downloadFilename: String,
    filter: [String, Array, Object],
    filterIncludedFields: Array,
    filterFunction: Function,
    searchPlaceholder: String,
  },
  data() {
    return {
      currentPage: 1,
      perPage: this.itemsPerPage ? this.itemsPerPage : 5,
      private_filter: null,
      filteredRows: null,
    };
  },
  computed: {
    totalRows() {
      if (this.filteredRows === 0) return 0;
      return this.filteredRows || this.items?.length || 0;
    },
  },
  methods: {
    boldRow(item, type) {
      if (!item || type !== "row") return;
      if (item.new) return "font-weight-bold";
    },
    onFiltered(list, count) {
      this.filteredRows = count;
      this.currentPage = 1;
      this.$emit("filtered");
    },
  },
};
</script>